var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-real-test-start examDetailsOwn" },
    [
      _c("MyDataDialog", {
        ref: "myDataDialog",
        on: { isValidationFace: _vm.isValidationFace },
      }),
      _vm.isFace
        ? _c("Face", {
            ref: "face",
            attrs: { examBasicUuid: _vm.exam_id.toString() },
            on: {
              isValidationFace: _vm.isValidationFace,
              isRouter: _vm.isRouter,
            },
          })
        : _vm._e(),
      _c("i", {
        staticClass: "iconfont iconfanhui",
        staticStyle: {
          "font-size": "30px",
          position: "absolute",
          margin: "10px 0 0 20px",
        },
        on: {
          click: function ($event) {
            return _vm.$router.go(-1)
          },
        },
      }),
      _c("div", { staticClass: "container" }, [
        _c("h1", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.dataText.exam_title)),
        ]),
        _c("h3", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.dataText.exam_course_title)),
        ]),
        _c("div", { staticClass: "real-content" }, [
          _c(
            "div",
            { staticStyle: { flex: "1" } },
            [
              _c("div", { staticClass: "test-info" }, [
                _c("p", { staticClass: "row" }, [
                  _c("span", [
                    _vm._v(" 科目： "),
                    _c(
                      "em",
                      {
                        staticClass: "primary",
                        staticStyle: { "font-style": "normal" },
                      },
                      [_vm._v(_vm._s(_vm.dataText.exam_course_title))]
                    ),
                  ]),
                  _c("span", [
                    _vm._v("堂次：" + _vm._s(_vm.dataText.exam_hall_title)),
                  ]),
                  _c("span", { staticStyle: { width: "40%" } }, [
                    _vm._v(
                      "考试时间: " +
                        _vm._s(_vm.dataText.exam_hall_start_time) +
                        " - " +
                        _vm._s(_vm.dataText.exam_hall_end_time)
                    ),
                  ]),
                ]),
                _c("p", { staticClass: "row" }, [
                  _c("span", [
                    _vm._v(" 考试总时长： "),
                    _c(
                      "em",
                      {
                        staticClass: "primary",
                        staticStyle: { "font-style": "normal" },
                      },
                      [_vm._v(_vm._s(_vm.dataText.exam_line_duration) + "分钟")]
                    ),
                  ]),
                  _c("span", [
                    _vm._v(
                      "共计：" +
                        _vm._s(_vm.dataText.exam_line_question_total) +
                        "道题"
                    ),
                  ]),
                  _c("span", [
                    _vm._v(
                      "总分：" +
                        _vm._s(_vm.dataText.exam_line_total_score) +
                        "分"
                    ),
                  ]),
                ]),
                _c("p", { staticClass: "row" }),
              ]),
              _c("div", { staticClass: "test-notice" }, [
                _c("p", { staticClass: "tit" }, [_vm._v("题型介绍：")]),
                _c("div", { staticStyle: { "white-space": "pre-line" } }, [
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.dataText.exam_line_introduction),
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "test-notice" }, [
                _c("p", { staticClass: "tit" }, [_vm._v("考试须知：")]),
                _c("div", { staticStyle: { "white-space": "pre-line" } }, [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.dataText.exam_notice) },
                  }),
                ]),
              ]),
              _c("br"),
              _c("br"),
              _c("el-checkbox", {
                model: {
                  value: _vm.is_notice,
                  callback: function ($$v) {
                    _vm.is_notice = $$v
                  },
                  expression: "is_notice",
                },
              }),
              _c("span", { staticClass: "is_notice" }, [
                _vm._v("我已阅读考试须知"),
              ]),
              _c(
                "span",
                {
                  staticClass: "onLineTips",
                  on: { click: _vm.operationProcess },
                },
                [_vm._v("《线上考试操作流程》")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "pab20", staticStyle: { "text-align": "center" } },
          [
            _c(
              "el-button",
              {
                staticClass: "start-btn",
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.startExamFun()
                  },
                },
              },
              [_vm._v("开始考试")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: { title: "考试须知", visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog", staticStyle: { padding: "0 0 10%" } },
            [
              _c("div", { staticStyle: { "white-space": "pre-line" } }, [
                _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.dataText.exam_notice) },
                }),
              ]),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                      _vm.is_notice = true
                    },
                  },
                },
                [_vm._v("我知道了")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }